import { TypographyVariantsOptions } from "@mui/material/styles";
import { CSSProperties } from "react";

export function remToPx(value: string) {
  return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value: number) {
  return `${value / 16}rem`;
}

export function responsiveFontSizes({
  sm,
  md,
  lg,
}: {
  sm: number;
  md: number;
  lg: number;
}) {
  return {
    "@media (min-width:600px)": {
      fontSize: pxToRem(sm),
    },
    "@media (min-width:900px)": {
      fontSize: pxToRem(md),
    },
    "@media (min-width:1200px)": {
      fontSize: pxToRem(lg),
    },
  };
}

declare module "@mui/material/styles" {
  interface TypographyVariants {
    s1: CSSProperties;
    s2: CSSProperties;
    s3: CSSProperties;
    s4: CSSProperties;
    s5: CSSProperties;
  }

  interface TypographyVariantsOptions {
    s1?: CSSProperties;
    s2?: CSSProperties;
    s3?: CSSProperties;
    s4?: CSSProperties;
    s5?: CSSProperties;
  }
}

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    s1: true;
    s2: true;
    s3: true;
    s4: true;
    s5: true;
  }
}

const Typography: TypographyVariantsOptions = {
  allVariants: {
    letterSpacing: pxToRem(0.5),
    color: "#171717",
  },
  fontFamily: ["Urbanist", "Helvetica", "sans-serif"].join(","),
  h1: {
    fontSize: pxToRem(48),
  },
  h2: {
    fontSize: pxToRem(40),
  },
  h3: {
    fontSize: pxToRem(36),
  },
  h4: {
    fontSize: pxToRem(32),
  },
  h5: {
    fontSize: pxToRem(24),
  },
  s1: {
    fontSize: pxToRem(20),
  },
  s2: {
    fontSize: pxToRem(16),
  },
  s3: {
    fontSize: pxToRem(14),
  },
  s4: {
    fontSize: pxToRem(12),
  },
  s5: {
    fontSize: pxToRem(10),
  },
};

export default Typography;
